"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateTokenDataFromJSON = GenerateTokenDataFromJSON;
exports.GenerateTokenDataFromJSONTyped = GenerateTokenDataFromJSONTyped;
exports.GenerateTokenDataToJSON = GenerateTokenDataToJSON;
exports.GenerateTokenDataToJSONTyped = GenerateTokenDataToJSONTyped;
function GenerateTokenDataFromJSON(json) {
    return GenerateTokenDataFromJSONTyped(json, false);
}
function GenerateTokenDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'authorizationCode': json['authorizationCode'],
    };
}
function GenerateTokenDataToJSON(value) {
    return GenerateTokenDataToJSONTyped(value, false);
}
function GenerateTokenDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'authorizationCode': value.authorizationCode,
    };
}
